export const BASE_URL = 'https://api.matador-bombas.com'
export const WEBSITE_URL = 'https://matador-bombas.com'
